/**
 * LogEntry Module
 *
 */

angular
  .module('log', ['ngResource', 'timeAgo', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when(CONFIG.url.log.all(), {controller: 'LogCtrl', templateUrl: '/r/static/templates/log/event-list.html'})
      .when(CONFIG.url.log.transactions(), {
        controller: 'LogTransactionsCtrl',
        templateUrl: '/r/static/templates/log/event-list.html',
      })
      .when(CONFIG.url.log.receipts(), {
        controller: 'LogReceiptsCtrl',
        templateUrl: '/r/static/templates/log/event-list.html',
      })
      .when(CONFIG.url.log.view(), {controller: 'LogViewCtrl', templateUrl: '/r/static/templates/log/single.html'})
  }])
  .factory('Log', ['$resource', function ($resource) {
    var Log = $resource(
      CONFIG.api('log'),
      {},
      {
        query: {method: 'POST', isArray: false, params: {id: 'all'}},
        get_receipt: {method: 'GET', params: {id: 'get_receipt'}},
      },
    )
    return Log
  }])

/* Controllers */

angular.module('log').controller('LogDashboardCtrl', ['$scope', '$rootScope', 'Log', function ($scope, $rootScope, Log) {
  Log.query(
    {id: 'all', limit: 3, transactions: false},
    // success handler
    function (data) {
      $scope.log = data.all_results
      $scope.count = data.all_count
      $scope.dashboard = true
      $rootScope.log_dashboard_ok = true
      a4.loaded($scope)
    },
    // error handler
    a4.restErrorFactory($scope),
  )
}])

function createScope($scope, Log, View) {
  $scope.utils.setPageTitle(_('activity_log'))
  $scope.utils.setPageID('logs')
  $scope.view = View

  $scope.paginate = function (page) {
    $scope.currentPage = $scope.utils.paginationHandler(page, $scope.numberOfPages)
  }

  Log.query(
    {id: 'all', transactions: true},
    // success handler
    function (data) {
      if (View == 'Transactions') {
        $scope.log = data.transaction_results
        $scope.count = data.transaction_count
        $scope.transaction_years = $scope.transaction_years.concat(
          data.transaction_years.map(function (year) {
            return {
              label: year.toString(),
              value: year,
            }
          }),
        )
      } else if (View == 'Receipts') {
        $scope.log = data.receipt_results
        $scope.count = data.receipt_count
      } else {
        $scope.log = data.all_results
        $scope.count = data.all_count
      }
      $scope.dashboard = false

      // pagination
      $scope.pageSize = 20
      $scope.numberOfPages = Math.ceil($scope.count / $scope.pageSize)
      $scope.currentPage = 0

      a4.loaded($scope)
    },
    // error handler
    a4.restErrorFactory($scope),
  )
}

angular.module('log').controller('LogCtrl', ['$scope', 'Log', '$rootScope', function ($scope, Log, $rootScope) {
  createScope($scope, Log, 'All')
}])

angular.module('log').controller('LogTransactionsCtrl', ['$scope', 'Log', '$rootScope', '$http', function ($scope, Log, $rootScope, $http) {
  // For loading transaction report XLS
  $scope.transaction_years = []
  $scope.selected_transaction_year = null

  $scope.loadTransactionReport = function () {
    if (!$scope.selected_transaction_year) return

    $scope.loading_report = true

    // Generate a unique filename with timestamp to ensure each download is treated as a new file
    // (prevents browser from overwriting or merging repeated downloads of the same report)
    function getDownloadFilename() {
      const year = $scope.selected_transaction_year
      const now = new Date()
      const downloadTimestamp =
        now.getFullYear() +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0') +
        'T' +
        String(now.getHours()).padStart(2, '0') +
        String(now.getMinutes()).padStart(2, '0') +
        String(now.getSeconds()).padStart(2, '0')
      return `${_('activity_log_transaction_report_filename')}-${year}-${downloadTimestamp}.xls`
    }

    $http({
      method: 'GET',
      url: CONFIG.url.log.transaction_report_xls(),
      params: {year: $scope.selected_transaction_year},
      responseType: 'blob',
    })
      .then(function (response) {
        const blob = new Blob([response.data], {type: response.headers('Content-Type') || 'application/vnd.ms-excel'})
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = getDownloadFilename()
        a.click()
        window.URL.revokeObjectURL(url)
      })
      .catch(function (err) {
        console.error('Transaction report download failed', err)
      })
      .finally(function () {
        $scope.loading_report = false
      })
  }

  createScope($scope, Log, 'Transactions')
}])

angular.module('log').controller('LogReceiptsCtrl', ['$scope', 'Log', '$rootScope', function ($scope, Log, $rootScope) {
  createScope($scope, Log, 'Receipts')
}])

angular.module('log').controller('LogViewCtrl', ['$scope', 'Log', '$routeParams', '$location', function ($scope, Log, $routeParams, $location) {
  $scope.utils.setPageTitle(_('activity_log_print_receipt'))
  $scope.utils.setPageID('logs')

  if ($routeParams.id) {
    Log.get_receipt(
      {id: $routeParams.id},
      function (l) {
        $scope.entry = l.receipt_text
        a4.loaded($scope)
      },
      a4.restErrorFactory($scope),
    )
  }

  $scope.cancel = function () {
    history.back()
  }
}])
